export default __webpack_public_path__ + "static/media/skull blue rose.6f55c2ed.png";